var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenseaGallery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_146",
    "data-name": "Group 146",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 37,
    viewBox: "0 0 34 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 34,
    height: 37,
    transform: "translate(0 0)",
    fill: "#262626"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M16.585,0A16.585,16.585,0,1,0,33.17,16.585,16.6,16.6,0,0,0,16.585,0M12.259,9.374a6.486,6.486,0,0,1,.721,7.211H7.932Zm15.864,10.1-2.088,1.043a2.149,2.149,0,0,0-1.079,1.244c-.693,2.079-2.638,4.2-4.83,4.2H13.548c-3.282,0-6.123-3-6.835-6.2L6.49,18.748h5.769a2.163,2.163,0,0,0,2.163,2.163h2.163V18.027H14.422c3.605-5.048-.721-10.1-.721-10.1l2.884.9V7.211a.721.721,0,0,1,1.442,0V9.278c7.932,4.711,2.163,8.749,2.163,8.749H18.027v2.884h2.338a1.8,1.8,0,0,0,1-.3l1.709-1.139,5.048-1.442Z",
    transform: "translate(0.411 2.137)",
    fill: "#262626"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenseaGallery);
export default __webpack_public_path__ + "static/media/opensea-gallery.642dfbf8b9de1488d29fa24bc7075f90.svg";
export { ForwardRef as ReactComponent };